export const socialsData = {
    github: 'https://github.com/tarek102',
    facebook: 'https://www.facebook.com/profile.php?id=100047654323640',
    linkedIn: 'https://www.linkedin.com/in/tarekyosry/',
    instagram: 'https://www.instagram.com/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/webdeveshverma',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@webdeveshverma',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}